"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Translate = void 0;
const Translate = exports.Translate = {
  /** 管理者 */
  Manager: 1,
  /** 普通 */
  Normal: 2,
  /** 个人 */
  Person: 3
};